<template>
  <WordGame />
</template>

<script>
import WordGame from './components/WordGame.vue'

export default {
  name: 'App',
  components: {
    WordGame
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 60px;
  margin: 20px auto;
  width: 390px;
}
</style>
